import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import {
    DiscussionLinkCompact,
    type IDiscussionLinkResponse,
} from "commonComponents/utilities/Discussions/DiscussionLinkCompact";

import "./columnDiscussion.less";

function columnDiscussionInternal(props: IGridCellRendererParams<IDiscussionLinkResponse>) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <div className={cn("ag-col-discussion", props.className)}>
                <DiscussionLinkCompact
                    id={props.value.id}
                    entityType={props.value.entityType}
                    builderId={props.value.builderId}
                    jobId={props.value.jobId}
                    commentCount={props.value.commentCount}
                    unreadCommentCount={props.value.unreadCommentCount}
                />
            </div>
        );
    }
    return null;
}

export const columnDiscussion = memo(columnDiscussionInternal);
